<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Search Box -->
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RLTD_TASK')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectTask"
              :selected="searchFrame.selectedCodeValue.searchTaskDivCode"
              :pageId="this.$options.name"
              :defaultOption="'all'"
              codeId="COD_COMP_RLTD_TASK_DIV"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="selectSite"
              :pageId="this.$options.name"
              :selected="searchFrame.selectedCodeValue.searchSiteId"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ERP_COMP_CD')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.gerpCompanyNumber"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GEHS_COMP_ID')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.companyId"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_COMP_CD')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.connectionCompanyNumber"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CORP_DSTG_NO')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.corpRegNumber"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_LCL_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.companyName"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_GLBL_NM')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="searchFrame.companyGlobalName"
              :placeholder="$t('MSG_TXT_INPUT_ITEM_NM')"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1" />
          <div class="col-xs-3" />
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset "
            @click="onResetClick"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :columnsautoresize="true"
        :dataset="'ds0'"
        :multiselect="false"
        :showDisplayCountControl="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:read="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="closePagePopup"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          v-permission:read="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ $t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00014', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      searchFrame: {
        selectedCodeValue: {
          searchSiteId: {
            key: '',
            label: '',
          },
          searchTaskDivCode: {
            key: '',
            label: '',
          },
        },
        companyId: '',
        connectionCompanyNumber: '',
        gerpCompanyNumber: '',
        corpRegNumber: '',
        companyName: '',
        companyGlobalName: '',
      },
      // Codes
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_GEHS_COMP_ID'),
        datafield: 'companyId',
      }, {
        text: this.$t('MSG_TXT_CONN_COMP_CD'),
        datafield: 'connectionCompanyNumber',
      }, {
        text: this.$t('MSG_TXT_ERP_COMP_CD'),
        datafield: 'gerpCompanyNumber',
      }, {
        text: this.$t('MSG_TXT_CORP_DSTG_NO'),
        datafield: 'corpRegNumber',
      }, {
        text: this.$t('MSG_TXT_COMP_LCL_NM'),
        datafield: 'companyName',
      }, {
        text: this.$t('MSG_TXT_COMP_GLBL_NM'),
        datafield: 'companyGlobalName',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'originalFinalModificationDTM', map: 'originalFinalModificationDTM' },
      { type: 'string', name: 'companyId', map: 'companyId' },
      { type: 'string', name: 'companyName', map: 'companyName' },
      { type: 'string', name: 'companyGlobalName', map: 'companyGlobalName' },
      { type: 'string', name: 'bizDivisionValue', map: 'bizDivisionValue' },
      { type: 'string', name: 'corpRegNumber', map: 'corpRegNumber' },
      { type: 'string', name: 'corpBizNumber', map: 'corpBizNumber' },
      { type: 'string', name: 'companyRepresentativeName', map: 'companyRepresentativeName' },
      { type: 'string', name: 'companyRepresentativeTelNumber', map: 'companyRepresentativeTelNumber' },
      { type: 'string', name: 'companyEstablishDTM', map: 'companyEstablishDTM' },
      { type: 'string', name: 'companyFaxNumber', map: 'companyFaxNumber' },
      { type: 'string', name: 'companyZipCode', map: 'companyZipCode' },
      { type: 'string', name: 'companyAddress', map: 'companyAddress' },
      { type: 'string', name: 'companyRepresentativeEmail', map: 'companyRepresentativeEmail' },
      { type: 'string', name: 'bizTypeName', map: 'bizTypeName' },
      { type: 'string', name: 'bizConditionsName', map: 'bizConditionsName' },
      { type: 'string', name: 'nationCode', map: 'nationCode' },
      { type: 'string', name: 'nationName', map: 'nationName' },
      { type: 'string', name: 'affiliatedCompanyYn', map: 'affiliatedCompanyYn' },
      { type: 'string', name: 'companyHomepageYn', map: 'companyHomepageYn' },
      { type: 'string', name: 'companyHomepageUrl', map: 'companyHomepageUrl' },
      { type: 'string', name: 'companyEmpValue', map: 'companyEmpValue' },
      { type: 'string', name: 'companyScaleCode', map: 'companyScaleCode' },
      { type: 'string', name: 'companyScaleValue', map: 'companyScaleValue' },
      { type: 'string', name: 'gerpCompanyNumber', map: 'gerpCompanyNumber' },
      { type: 'string', name: 'connectionCompanyNumber', map: 'connectionCompanyNumber' },
      { type: 'string', name: 'companyAccountGroupCode', map: 'companyAccountGroupCode' },
      { type: 'string', name: 'companyAccountGroupName', map: 'companyAccountGroupName' },
      { type: 'string', name: 'companyCloseAccountsDTM', map: 'companyCloseAccountsDTM' },
      { type: 'string', name: 'companyCapitalAmount', map: 'companyCapitalAmount' },
      { type: 'string', name: 'companyCapitalSumAmount', map: 'companyCapitalSumAmount' },
      { type: 'string', name: 'companyDebtSumAmount', map: 'companyDebtSumAmount' },
      { type: 'string', name: 'companyDebtRatioValue', map: 'companyDebtRatioValue' },
      { type: 'string', name: 'companyCapitalSurplusAmount', map: 'companyCapitalSurplusAmount' },
      { type: 'string', name: 'companyTradePossibilityYn', map: 'companyTradePossibilityYn' },
      { type: 'string', name: 'companyRegistrationStateCode', map: 'companyRegistrationStateCode' },
      { type: 'string', name: 'companyRegistrationStateName', map: 'companyRegistrationStateName' },
      { type: 'string', name: 'companyUseYn', map: 'companyUseYn' },
      { type: 'string', name: 'companyRegistrationApprovalId', map: 'companyRegistrationApprovalId' },
      { type: 'string', name: 'vendorTaskSiteList', map: 'vendorTaskSiteList' },
      { type: 'string', name: 'vendorCategoryList', map: 'vendorCategoryList' },
      { type: 'string', name: 'vendorCreditEvaluationCOMMDVO', map: 'vendorCreditEvaluationCOMMDVO' },
      { type: 'string', name: 'vendorCorporateBodyCOMMDVO', map: 'vendorCorporateBodyCOMMDVO' },
      { type: 'string', name: 'searchSiteId', map: 'searchSiteId' },
      { type: 'string', name: 'searchTaskDivCode', map: 'searchTaskDivCode' },
      { type: 'string', name: 'finalModificationStartDTM', map: 'finalModificationStartDTM' },
      { type: 'string', name: 'finalModificationEndDTM', map: 'finalModificationEndDTM' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          this.$refs.selectSite.reset();
          this.$refs.selectTask.reset();
        } else {
          this.searchFrame[key] = '';
        }
      });
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onSearchClick() {
      const searchData = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMY_00071', {
        query: searchData,
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onSelectClick() {
      const selectedData = this.ds0.getSelectedRawData();
      if (selectedData.length === 1) {
        this.closePagePopup(selectedData);
      } else {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_NUM_SELECT'), 1, this.$t('MSG_TXT_COMP')));
      }
    },
  },
};
</script>
<style scoped>
</style>
